import { FC } from 'react'
import LibraryPageBase, { type LibraryPageProps } from './LibraryPageBase'
import { operationsLibraryApi } from '../core/libraryApi'

type OperationsLibraryPageProps = Omit<LibraryPageProps, 'api'> & {
    api?: LibraryPageProps['api']
}

const LibraryPage: FC<OperationsLibraryPageProps> = ({ api, ...rest }) => {
    return <LibraryPageBase api={api ?? operationsLibraryApi} {...rest} />
}

export { LibraryPage }
